(function () {
	'use strict';

	angular.module('smb-app')
		.directive('smbToDoList', [ToDoListDirective])
		.controller('ToDoListController',
		[
			'gettextCatalog',
			'smbToolbarService',
			'smbToDoListDataStore',
			'smbIconTypes',
			'smbDocumentViewerNavigationService',
			ToDoListController
		]);

	var templateUrl = require('./todolist.template');
	function ToDoListDirective() {
		return {
			restrict: 'E',
			controller: ToDoListController,
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {

			}
		};
	}

	function ToDoListController(gettextCatalog, smbToolbarService, smbToDoListDataStore, smbIconTypes, smbDocumentViewerNavigationService) {
		smbToolbarService.set(gettextCatalog.getString('My To Do List'), 'content.home', false, false);

		var vm = this;
		vm.toDoListDS = smbToDoListDataStore;
		vm.viewState = viewState;
		vm.defaultIconType = smbIconTypes[smbIconTypes.SVG];

		(function loadToDoList() {
			smbToDoListDataStore.getDocuments();
		})();

		function viewState(doc) {
			smbDocumentViewerNavigationService.go(doc.LibraryId, doc.FolderId, doc.DocumentId);
		}
	}
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/todolist/todolist.js
// module id = 97
// module chunks = 1